import React from "react";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Tooltip from "@mui/material/Tooltip";
import QuestionIcon from "@mui/icons-material/HelpOutline";

const SchoolWiseReportsTable = ({ schools, currentEducationYear }) => {
  return (
    <div>
      <h4 style={{ marginTop: "0px" }}>OKUL BAZLI MUHASEBE RAPORU</h4>
      <TableContainer
        component={Paper}
        sx={{
          minWidth: 650,
          width: "inherit",
        }}
      >
        <Table
          sx={{ minWidth: 650, width: "100%", justifyContent: "center", margin: "auto" }}
          stickyHeader
          aria-label="school wise reports table"
        >
          <TableHead>
            <TableRow
              sx={{
                "& th": {
                  backgroundColor: "white",
                  borderBottom: "2px solid #e0e0e0",
                  fontWeight: "bold",
                  zIndex: 1,
                },
              }}
            >
              <TableCell>
                <div style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
                  <b>OKUL</b>
                </div>
              </TableCell>
              <TableCell>
                <div style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
                  <b>YILLIK ALACAK</b>
                  <Tooltip
                    title={
                      currentEducationYear.name + " eğitim yılı için bu okula ait öğrenci sözleşmelerinin toplam tutarı"
                    }
                  >
                    <QuestionIcon sx={{ marginLeft: "5px", color: "gray", width: "20px", height: "auto" }} />
                  </Tooltip>
                </div>
              </TableCell>
              <TableCell>
                <div style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
                  <b>TOPLAM TAHSİLAT</b>
                  <Tooltip
                    title={currentEducationYear.name + " eğitim yılına ait sözleşmelere girilen tahsilatların toplamı"}
                  >
                    <QuestionIcon sx={{ marginLeft: "5px", color: "gray", width: "20px", height: "auto" }} />
                  </Tooltip>
                </div>
              </TableCell>
              <TableCell>
                <div style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
                  <b>TOPLAM İADE</b>
                  <Tooltip
                    title={currentEducationYear.name + " eğitim yılına ait sözleşmelere girilen iadelerin toplamı"}
                  >
                    <QuestionIcon sx={{ marginLeft: "5px", color: "gray", width: "20px", height: "auto" }} />
                  </Tooltip>
                </div>
              </TableCell>
              <TableCell>
                <div style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
                  <b>TOPLAM GİDER</b>
                  <Tooltip
                    title={
                      <span style={{ whiteSpace: "pre-line" }}>
                        {`Sözleşmelerden bağımsız olarak ${currentEducationYear.yearStartDate} ve ${currentEducationYear.yearEndingDate} tarihleri arasında girilen giderlerin toplamı.

Bu tarihler hizmet dönemleri sekmesinde ${currentEducationYear.name} eğitim yılı için girilen başlangıç ve bitiş tarihlerine göre hesaplanır.`}
                      </span>
                    }
                    componentsProps={{
                      tooltip: {
                        sx: {
                          width: 650,
                          maxWidth: 800,
                          whiteSpace: "normal",
                        },
                      },
                    }}
                  >
                    <QuestionIcon sx={{ marginLeft: "5px", color: "gray", width: "20px", height: "auto" }} />
                  </Tooltip>
                </div>
              </TableCell>
              <TableCell>
                <div style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
                  <b>NET GELİR</b>
                  <Tooltip
                    title={
                      <span style={{ whiteSpace: "pre-line" }}>
                        {`Bu okul için net gelir durumu.
                        Tahsilatlardan, iadelerin ve giderlerin çıkarılması ile hesaplanır.`}
                      </span>
                    }
                    componentsProps={{
                      tooltip: {
                        sx: {
                          width: 400,
                          maxWidth: 800,
                          whiteSpace: "normal",
                        },
                      },
                    }}
                  >
                    <QuestionIcon sx={{ marginLeft: "5px", color: "gray", width: "20px", height: "auto" }} />
                  </Tooltip>
                </div>
              </TableCell>
              <TableCell>
                <div style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
                  <b>KALAN TOPLAM ALACAK</b>
                  <Tooltip
                    title={
                      <span style={{ whiteSpace: "pre-line" }}>
                        {`Bu okul için ileri tarihli kalan geliri gösterir.
                        Sözleşmeler toplamından, tahsilatlar toplamanın çıkarılması ile hesaplanır.
                        İadeler ve giderler dikkate alınmaz.
                        `}
                      </span>
                    }
                    componentsProps={{
                      tooltip: {
                        sx: {
                          width: 450,
                          maxWidth: 800,
                          whiteSpace: "normal",
                        },
                      },
                    }}
                  >
                    <QuestionIcon sx={{ marginLeft: "5px", color: "gray", width: "20px", height: "auto" }} />
                  </Tooltip>
                </div>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {schools.map((school) => (
              <TableRow key={school.id} sx={{ "&:last-child td, &:last-child th": { border: 0 } }}>
                <TableCell component="th" scope="row">
                  <strong>{school.name}</strong>
                </TableCell>

                <TableCell>{school?.contracts?.amount.toLocaleString()}</TableCell>

                <TableCell>{school?.receipts?.amount.toLocaleString()}</TableCell>

                <TableCell>{school.withdraws?.amount.toLocaleString()}</TableCell>

                <TableCell>{school.expenses.amount.toLocaleString()}</TableCell>

                <TableCell>
                  {(school.receipts.amount - school.expenses.amount - school.withdraws.amount).toLocaleString()}
                </TableCell>

                <TableCell>{(school.contracts.amount - school.receipts.amount).toLocaleString()}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <br />
      <br />
    </div>
  );
};

export default SchoolWiseReportsTable;
